<template lang="">
    <div class="wrapper">
        <div class="label" v-if="label">{{label}}</div>
        
        <slot></slot>
    </div>
</template>
<script>
export default {
  props: {
    label: {
      type: String,
      required: false,
    },
  },
};
</script>
<style lang="scss">
$brand-primary: #aaaaaa;
.wrapper {
  border: 1px solid #000;
  padding: 20px;
  margin: 10px;
  border-radius: 2%;
  .label {
    position: absolute;
    top: -10px;
    background-color: $brand-primary;
    border: 1px solid #000;
    padding: 6px;
    font-weight: bold;
  }
}
</style>